import type { FC } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useScheduleCacheEnabled } from "../../hooks/useScheduleWeekRules";
import { useStaffSchedulePath } from "../../hooks/useStaffSchedulePath";
import { NurseSchedule } from "./NurseSchedule";

/**
 * The employee-staffing page, drawn from the old list. With `staffing_schedule_cache` on that list never loads, so an
 * old link or bookmark goes to the person's profile instead, as every link there does.
 */
export const NurseScheduleRoute: FC = () => {
	const { id, draftMode } = useParams();
	const isCacheEnabled = useScheduleCacheEnabled();
	const staffSchedulePath = useStaffSchedulePath();
	if (!isCacheEnabled) return <NurseSchedule />;
	return <Navigate to={staffSchedulePath(Number(id), draftMode === "true")} replace />;
};
